import Commons from '../../../../Services/Common/Common';

/**
 * 통계(ACS_BASIC_03) 스키마
 */
export const ACS_BASIC_03_Schema = {
  mapper: {
    /** GetAccBasic03R1 - CustCd, Year (암호화된 사업장코드, 암호화된 조회년도) */
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      Year: (_, context) =>
        Commons.EncryptAES(context.search?.year || '') || '',
    },
    /** GetAccBasic04R1 - CustCd, StartDate, EndDate (암호화, YYYY-MM-DD) 재해율 조회 */
    search2: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      StartDate: (_, context) => {
        const year = context.search?.year || '';
        if (!year) return '';
        return Commons.EncryptAES(`${year}-01-01`) || '';
      },
      EndDate: (_, context) => {
        const year = context.search?.year || '';
        if (!year) return '';
        return Commons.EncryptAES(`${year}-12-31`) || '';
      },
    },
  },
};

/**
 * GetAccBasic03R1 응답에서 통계 객체 추출 (Data[0])
 * - byMonth, byType, byDayOfWeek, byDept, byTime, byTenure
 */
export const extractStatData = (response) => {
  const raw = response ?? {};
  const list = Array.isArray(raw?.data)
    ? raw.data
    : Array.isArray(raw)
      ? raw
      : [];
  const first = list[0];
  if (!first) return null;
  return {
    byMonth: first.byMonth ?? [],
    byType: first.byType ?? [],
    byDayOfWeek: first.byDayOfWeek ?? [],
    byDept: first.byDept ?? [],
    byTime: first.byTime ?? [],
    byTenure: first.byTenure ?? [],
  };
};

/**
 * GetAccBasic04R1 응답에서 재해율 데이터 추출 (Data[0])
 * - WorkerCount(상시근로자수), AccidentCount(재해건수), AccidentRate(재해율 %)
 */
export const extractAccidentRateData = (response) => {
  const raw = response ?? {};
  const list = Array.isArray(raw?.data)
    ? raw.data
    : Array.isArray(raw?.Data)
      ? raw.Data
      : [];
  const first = list[0];
  if (!first) return null;
  const workerCount = first.workerCount ?? 0;
  const accidentCount = first.accidentCount ?? 0;
  const accidentRate = first.accidentRate ?? null;
  return {
    workerCount: Number(workerCount),
    accidentCount: Number(accidentCount),
    accidentRate: accidentRate != null ? Number(accidentRate) : null,
  };
};
